import ImgAuthority from '@/sealFilter/ImgAuthority'
import {requestAuthority,postRequest} from '@/sealFilter/requestAuthority.js'

export function queryPublisher (data) {
  return ImgAuthority({
    url: 'pubcom/pb/orgs/action/search/list',
    method: 'post',
    params: data
  })
}
 
// export function queryActionList (data) {
//   return requestAuthority({
//     url: '/link/action/list',
//     method: 'post',
//     params: data
//   })
// }
let  queryActionList =(data)=>postRequest('/link/action/list',data)
let  queryActionList2 =(data)=>postRequest('/link/action/page',data)
let  deleteActionRow =(data)=>postRequest('/link/action/delete',data)
let  savePublisher =(data)=>postRequest('/link/action/create',data)
let  updatPublisher =(data)=>postRequest('/link/action/update',data)
let  bookList =(data)=>postRequest('/link/action/listBook',data)
let  bookSelectList =(data)=>postRequest('/exhibitionGood/action/pageExhibitionGood',data)
let  bookQueryList =(data)=>postRequest('/exhibitionGood/action/listExhibitionGood',data)
let  queryGoods =(data)=>postRequest('/exhibitionGood/action/pageOrder',data)
let  saveGoods =(data)=>postRequest('/exhibitionGood/action/create',data)
let  UpdateGoods =(data)=>postRequest('/exhibitionGood/action/update',data)

// export function UpdateGoods (data) {
//   return requestAuthority({
//     url: '/exhibitionGood/action/update',
//     method: 'post',
//     data
//   })
// }
// 保存商品
// export function saveGoods (data) {
//   return requestAuthority({
//     url: '/exhibitionGood/action/create',
//     method: 'post',
//     data
//   })
// }

// export function savePublisher (data) {
//   return requestAuthority({
//     url: '/link/action/create',
//     method: 'post',
//     data,
//     headers: { 'Content-Type': 'application/json' },
//   })
// }
export{
  queryActionList,queryActionList2,deleteActionRow,savePublisher,updatPublisher,bookList,bookSelectList,bookQueryList,queryGoods,saveGoods,UpdateGoods
}
// export function queryActionList2 (data) {
//   return requestAuthority({
//     url: '/link/action/page',
//     method: 'post',
//     params: data
//   })
// }
// export function deleteActionRow (data) {
//   return requestAuthority({
//     url: '/link/action/delete',
//     method: 'post',
//     params: data
//   })
// }
// export function savePublisher (data) {
//   return requestAuthority({
//     url: '/link/action/create',
//     method: 'post',
//     data,
//     headers: { 'Content-Type': 'application/json' },
//   })
// }
// export function updatPublisher (data) {
//   return requestAuthority({
//     url: '/link/action/update',
//     method: 'post',
//     data,
//     headers: { 'Content-Type': 'application/json' },
//   })
// }
// export function bookList (data) {
//   return requestAuthority({
//     url: '/link/action/listBook',
//     method: 'post',
//     params: data
//   })
// }
// export function bookSelectList (data) {
//   return requestAuthority({
//     url: '/exhibitionGood/action/pageExhibitionGood',
//     method: 'post',
//     data
//   })
// }
// export function bookQueryList (data) {
//   return requestAuthority({
//     url: '/exhibitionGood/action/listExhibitionGood',
//     method: 'post',
//     data
//   })
// }

export function sysUpdate (data, position) {
  return requestAuthority({
    url: '/link/action/sortPosition?position=' + position,
    method: 'post',
    data
  })
}
// 保存商品
// export function queryGoods (data) {
//   return requestAuthority({
//     url: '/exhibitionGood/action/pageOrder',
//     method: 'post',
//     params: data
//   })
// }
// 保存商品
// export function saveGoods (data) {
//   return requestAuthority({
//     url: '/exhibitionGood/action/create',
//     method: 'post',
//     data
//   })
// }
// 更新商品
// export function UpdateGoods (data) {
//   return requestAuthority({
//     url: '/exhibitionGood/action/update',
//     method: 'post',
//     data
//   })
// }



// WEBPACK FOOTER //
// ./src/api/sysinfo.js